import { useEffect, useCallback } from "react";
import { useStores } from "../../../stores/setup/use-store";
import { useLocationDrawer } from "./useLocationDrawer";
import { useLocationSearch } from "./useLocationSearch";
import { useLocationTableColumns } from "./useLocationTableColumns";
import { useLocationActions } from "./useLocationActions";
import { useLocationNotifications } from "./useLocationNotifications";
import { useLocation } from "react-router-dom";

export const useLocationPage = () => {
	const {
		dataStores: { locationStore, insightAlertStore },
	} = useStores();

	const location = useLocation();
	const drawerHook = useLocationDrawer();
	const searchHook = useLocationSearch();
	const columnsHook = useLocationTableColumns();
	const actionsHook = useLocationActions(drawerHook.handleOpenDrawer, drawerHook.handleOpenModal);

	useLocationNotifications();

	useEffect(() => {
		const queryParams = new URLSearchParams(location.search);
		const editLocationId = queryParams.get("edit_location_id");
		const createLocation = queryParams.get("create_location");

		if (editLocationId) {
			locationStore.setIsEditing(true);
			locationStore.setDrawerOpen(true);

			const newURL = new URL(window.location.href);
			newURL.searchParams.delete("edit_location_id");
			window.history.replaceState({}, "", newURL.toString());
		} else if (createLocation === "true") {
			locationStore.setSelectedLocation(null);
			locationStore.setIsEditing(false);
			locationStore.setDrawerOpen(true);

			const newURL = new URL(window.location.href);
			newURL.searchParams.delete("create_location");
			window.history.replaceState({}, "", newURL.toString());
		} else {
			locationStore.setDrawerOpen(false);
			locationStore.setIsEditing(false);
			locationStore.setCreateFormValues(null);
			locationStore.getLocationsAPI();
		}
	}, [location.search]); // eslint-disable-line react-hooks/exhaustive-deps

	const handlePageChange = useCallback((page: number) => {
		locationStore.setCurrentPage(page);
		locationStore.getLocationsAPI();
	}, [locationStore]);

	return {
		locationStore,
		...drawerHook,
		...searchHook,
		...columnsHook,
		...actionsHook,
		enablePagination: true,
		currentPage: locationStore.currentPage,
		pageSize: locationStore.pageSize,
		totalItems: locationStore.totalLocations,
		handlePageChange,
		isGeofenceInvalid: insightAlertStore.isGeofenceInvalid,
	};
};